module.exports = "\n<!--suppress HtmlFormInputWithoutLabel -->\n<input type=\"text\"\n       v-model=\"value\"\n       placeholder=\"Numéro français ou +XX indicatif\">\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/InputPhone.vue
// module id = 498
// module chunks = 0